export default {"src":"/_next/static/media/Welcome.89bd14fb.svg","height":421,"width":396,"blurWidth":0,"blurHeight":0};